import React, { memo } from 'react';
import { Adalicon, FaIcon } from '../common/Icons.jsx';
import { useDispatch, useSelector } from 'react-redux';
import { closeSidebar, openSidebarTheme } from './redux/dashboardSlice.js';
import { useCompleteRefresh } from './hooks/useRefreshData.js';

function HeaderGen2({editing, setEditing, returnUrl, toggleLibrary}) {
  const { completeRefresh } = useCompleteRefresh();
  const dispatch = useDispatch();
  const sidebarOpen = useSelector(state => state.dashboard.sidebarOpen);
  const editingWidgetId = useSelector(state => state.dashboard.editingId);
  const goBack = () => {if (returnUrl) Turbo.visit(returnUrl)};
  const toggleSidebar = () => {
    if (sidebarOpen){
      dispatch(closeSidebar());
    } else {
      dispatch(openSidebarTheme());
    }
  }

  if (!editing) {
    return <button className="btn btn-primary floating-button"
      onClick={() => setEditing(true)}>
      <i className="fa fa-pencil"></i>
    </button>
  }
  return (
    <div className={`clearfix fixed-bottom dashboard-toolbar ${editingWidgetId ? 'hidden' : ''}`}>
        {editing &&
        <button className='btn btn-default float-right' onClick={toggleSidebar} >
          <FaIcon type='palette' /> {I18n.t('theme')}
        </button>}
      {(editing ?
        <button className="btn btn-primary" style={{marginLeft: 15}}
          onClick={toggleLibrary}>
            <FaIcon type='plus' className='mr-1' />{I18n.t('add_widgets')}
        </button> : null)}
      {/* {goBack ? (
        <button className="btn btn-primary float-right"
          onClick={goBack}>
          {I18n.t('return_to_list')}
        </button>
      ) : null} */}
      <button className={`btn btn-${goBack ? "default" : "primary"} float-right${goBack ? " mr-2" : ""}`}
        onClick={() => setEditing(false)}>
        {goBack ? (
          <>
            <Adalicon type="eye" /> {I18n.t('view_dashboard')}
          </>
          ) : I18n.t('stop_editing')}
      </button>
      <button className='btn btn-default float-right mr-2' onClick={completeRefresh} >
        <FaIcon type='refresh' /> {I18n.t('refresh')}
      </button>
    </div>)
}

export default memo(HeaderGen2);